import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-classic-button-block',
  templateUrl: './classic-button-block.component.html',
})
export class ClassicButtonBlockComponent {
  @Input() url!: string;
  @Input() label!: string;
  @Input() onSiteLocationId!: string;
  @Input() thickSize: 'S' | 'M' | 'L' = 'M';
  @Input() type: 'primary' | 'light' | 'outlined' = 'primary';
  @Input() color: 'neutral' | 'success' | 'primary' | 'info' | 'highligh' = 'primary';
}
